<template>
    <div
        class="persona-teaser"
        :title="`Mehr zu ${name}`"
    >
        <img
            class="image"
            :src="require('@/assets/personas/' + $vnode.key + '.jpg')"
        >
        <div class="label">
            {{ attribute }}:<br>
            <b>{{ name }}</b>
        </div>
    </div>
</template>

<script>

export default {
    name: 'PersonaTeaser',
    props: {
        name: {
            type: String,
            required: true
        },
        attribute: {
            type: String,
            required: true
        }
    }
};
</script>

<style lang="scss" src="./Teaser.scss" />
